module.exports = __webpack_public_path__ + "img/new-entity.99e7254f.svg";